var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCenter = function SvgCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    style: {
      color: "#6a89a6"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.234 11a.89.89 0 0 1 .891-.89h13.75a.89.89 0 0 1 0 1.78H9.125a.89.89 0 0 1-.89-.89Zm2.136 2.495a.89.89 0 0 1 .63-.26h10a.89.89 0 0 1 0 1.78H11a.89.89 0 0 1-.63-1.52ZM9.125 16.36h13.75a.89.89 0 0 1 0 1.782H9.125a.89.89 0 1 1 0-1.782ZM11 19.484h10a.89.89 0 0 1 0 1.782H11a.89.89 0 0 1 0-1.782Z"
  })));
};
export default SvgCenter;